import { useEffect } from "react";
import { useRouter } from "next/router";
import { getRandomSeed } from "@/utils/getRandomSeed";

export default function useSeedEffect() {
	const router = useRouter();

	useEffect(() => {
		if (!router.isReady) return;

		if (!router.query.seed) {
			let seed = sessionStorage.getItem("seed") ?? getRandomSeed();

			router.replace(
				{
					query: {
						...router.query,
						seed,
					},
				},
				undefined,
				{ shallow: true }
			);
		} else {
			if (!sessionStorage.getItem("seed")) {
				sessionStorage.setItem("seed", router.query.seed as string);
			}
		}
	});
}
